import React, { useEffect } from "react";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import translate from "../../../i18n/translate";

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Toaster = (props: any) => {
    const [open, setOpen] = React.useState(false);
    useEffect(() => {
        setOpen(true);
    }, [props.open]);
    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        props.toasterClosed();
    };
    const returnMessageOnSeverity = (severity: string, messageKey: string) => {
        let messageFragment: any;
        switch(severity){
            case 'error':
                messageFragment = <React.Fragment>{translate(messageKey) || translate("message_errorDefault")}</React.Fragment>
            break;
            case 'warning':
                messageFragment =  <React.Fragment>{translate(messageKey) || translate("message_unknownError")}</React.Fragment>
            break;
            case 'success':
                messageFragment =  <React.Fragment>{translate(messageKey) || translate("message_successUpdated")}</React.Fragment>
            break;
            case 'info':
                messageFragment =  <React.Fragment>{translate(messageKey) || translate("message_unknownError")}</React.Fragment>
            break;
            case 'default':
                messageFragment =  <React.Fragment>{translate(messageKey) || translate("message_errorDefault")}</React.Fragment>
            break;
        }
        return messageFragment;
    }

    const getAlertColors = (severity: string) => {
        if(severity === "error"){
            return { backgroundColor: '#e40000', color: '#fff' }
        } else if(severity === "warning"){
            return { backgroundColor: '#ff9800', color: '#fff' }
        } else if(severity === "success"){
            return { backgroundColor: '#4caf50', color: '#fff' }
        } else if(severity === "info"){
            return { backgroundColor: '#2196f3', color: '#fff' }
        } else if(severity === "default"){
            return { backgroundColor: '#e40000', color: '#fff' }
        } else {
            return { backgroundColor: '#e40000', color: '#fff' }
        }
    }
    return (
        <React.Fragment>
            {props.open && open && <Snackbar
                open={open}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                autoHideDuration={props.duration || 2000}
                onClose={handleClose}>                
                <Alert onClose={handleClose} style={{ display: 'none', ...getAlertColors(props.severity) }} severity={props.severity || "error"}>{returnMessageOnSeverity(props.severity,props.messageKey)}</Alert>
            </Snackbar >}
        </React.Fragment>
    )
}

export default Toaster